/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface AddMedicalSystemOptionsDto
 */
export interface AddMedicalSystemOptionsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddMedicalSystemOptionsDto
     */
    category?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddMedicalSystemOptionsDto
     */
    subCategory?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddMedicalSystemOptionsDto
     */
    manufacturer?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddMedicalSystemOptionsDto
     */
    model?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddMedicalSystemOptionsDto
     */
    subModel?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddMedicalSystemOptionsDto
     */
    beamLimitingDeviceType?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddMedicalSystemOptionsDto
     */
    beamProduction?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AddMedicalSystemOptionsDto
     */
    $type?: AddMedicalSystemOptionsDtoTypeEnum;
}


/**
 * @export
 */
export const AddMedicalSystemOptionsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoAddMedicalSystemOptionsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.AddMedicalSystemOptionsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type AddMedicalSystemOptionsDtoTypeEnum = typeof AddMedicalSystemOptionsDtoTypeEnum[keyof typeof AddMedicalSystemOptionsDtoTypeEnum];


/**
 * Check if a given object implements the AddMedicalSystemOptionsDto interface.
 */
export function instanceOfAddMedicalSystemOptionsDto(value?: unknown): value is AddMedicalSystemOptionsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AddMedicalSystemOptionsDtoTypeEnum)[0];
}

export function AddMedicalSystemOptionsDtoFromJSON(json: any): AddMedicalSystemOptionsDto {
    return AddMedicalSystemOptionsDtoFromJSONTyped(json, false);
}

export function AddMedicalSystemOptionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddMedicalSystemOptionsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': !exists(json, 'category') ? undefined : json['category'],
        'subCategory': !exists(json, 'subCategory') ? undefined : json['subCategory'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'model': !exists(json, 'model') ? undefined : json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'beamLimitingDeviceType': !exists(json, 'beamLimitingDeviceType') ? undefined : json['beamLimitingDeviceType'],
        'beamProduction': !exists(json, 'beamProduction') ? undefined : json['beamProduction'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function AddMedicalSystemOptionsDtoToJSON(value?: AddMedicalSystemOptionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'category': value.category,
        'subCategory': value.subCategory,
        'manufacturer': value.manufacturer,
        'model': value.model,
        'subModel': value.subModel,
        'beamLimitingDeviceType': value.beamLimitingDeviceType,
        'beamProduction': value.beamProduction,
        '$type': value.$type,
    });
}

